/* clone-rv-sticky-offer: thanh cố định đáy màn hình, chỉ hiện khi buy box (#rv-buy) đã cuộn ra khỏi màn hình phía trên.
   Không có buy box trên trang → hiện khi đã cuộn quá một màn hình. Trong theme editor: hiện khi chọn section. */
if (!customElements.get('rv-sticky-offer')) {
  class RvStickyOffer extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.rv-sticky-offer__bar');
      this.spacer = this.querySelector('.rv-sticky-offer__spacer');
      this.button = this.querySelector('.rv-sticky-offer__button');
      this.forced = false;
      this.passed = false;
      this.setVisible(false);

      const target = document.getElementById(this.dataset.target || 'rv-buy');
      if (target && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            // Đã cuộn qua: không còn giao với màn hình và nằm phía trên mép trên
            this.passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            this.update();
          });
        });
        this.observer.observe(target);
      } else {
        this.onScroll = () => {
          this.passed = window.scrollY > window.innerHeight;
          this.update();
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.syncSpacer());
        this.resizeObserver.observe(this.bar);
      }

      if (window.Shopify && window.Shopify.designMode) {
        this.onSelect = (event) => {
          if (event.detail && event.detail.sectionId === this.dataset.sectionId) {
            this.forced = event.type === 'shopify:section:select';
            this.update();
          }
        };
        document.addEventListener('shopify:section:select', this.onSelect);
        document.addEventListener('shopify:section:deselect', this.onSelect);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onSelect) {
        document.removeEventListener('shopify:section:select', this.onSelect);
        document.removeEventListener('shopify:section:deselect', this.onSelect);
      }
    }

    update() {
      this.setVisible(this.forced || this.passed);
    }

    setVisible(visible) {
      this.visible = visible;
      this.classList.toggle('is-visible', visible);
      this.bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (this.button) this.button.setAttribute('tabindex', visible ? '0' : '-1');
      this.syncSpacer();
    }

    // Chừa chỗ cuối trang bằng chiều cao thanh (như position: sticky của bản gốc) để không che nội dung cuối.
    syncSpacer() {
      if (!this.spacer || !this.bar) return;
      this.spacer.style.height = this.visible ? `${this.bar.offsetHeight}px` : '0px';
    }
  }

  customElements.define('rv-sticky-offer', RvStickyOffer);
}
